import React, {useContext, useEffect} from 'react';
import { useAccount } from 'wagmi';
import { ModalContext } from '../../context-providers/ModalProvider';
import { formatCurrencyAmount } from '../../helpers/formatters';
import { balanceStore } from '../../stores/BalanceStore';
import { observer } from 'mobx-react';
import DepositDialog from '../modals/DepositDialog/DepositDialog';
import WithdrawDialog from '../modals/WithdrawDialog/WithdrawDialog';
import './BalanceWidget.scss';
import NereusButton from '../NereusButton/NereusButton';
import {useSwitchChainToPolygon} from "../../hooks/useSwitchChainToPolygon";
import {useBreakpointContext} from "../../context-providers/BreakpointProvider";

const BalanceWidget: any = observer(({bridgeButton}: any) => {
    const { address} = useAccount();

    const { openModal } = useContext(ModalContext);
    const { md, sm, xs } = useBreakpointContext();


    const switchChainToPolygon = useSwitchChainToPolygon();

    const [hasWithdrawBtn, setHasWithdrawBtn] = React.useState<boolean>(false);

    useEffect(() => {
        setHasWithdrawBtn(Number(balanceStore.usdtAvailableBalanceDecimal) > 0);
    }, [balanceStore.usdtAvailableBalanceDecimal])

    const handleOpenDepositModal = async () => {
        try {
            await switchChainToPolygon()
            openModal(<DepositDialog/>)
        } catch (err) {
            console.error("Deposit error", err)
        }
    };
    const handleOpenWithdrawModal = async () => {
        try {
            await switchChainToPolygon()
            openModal(<WithdrawDialog/>)
        } catch (err) {
            console.error("Withdraw error", err)
        }
    };

    useEffect(() => {
        if (address) {
            balanceStore.fetchBalance(address);
        } else {
            balanceStore.resetState()
        }
    }, [address]);

    const depositButton = (
        <NereusButton className="flex-1" variant="contained" disabled onClick={handleOpenDepositModal}>
            Deposit
        </NereusButton>
    )

    const withdrawButton = (
        <NereusButton className="flex-1" variant="outlined" color="secondary" onClick={handleOpenWithdrawModal}>
            Withdraw
        </NereusButton>
    )
    return (
        <div className="BalanceWidget">
            <div className="BalanceWidget__balance-wrapper">
                <label className="App-label">Balance</label>
                <p className="BalanceWidget__balance nereus-title-m mt-1 mb-2 nereus-color-neutral-white">{formatCurrencyAmount(balanceStore.usdtAvailableBalanceDecimal, 'USDT')}</p>
            </div>
            {md && (
                <div className="flex gap-4">
                    {depositButton}
                    {bridgeButton}
                    {hasWithdrawBtn && (withdrawButton)}
                </div>
            )}
            {(xs || sm) && (
                <div className="flex gap-4">
                    {hasWithdrawBtn && (withdrawButton)}
                    {bridgeButton}
                    {depositButton}
                </div>
            )}
        </div>
    );
});

export default BalanceWidget;
